import { Button } from '~/components/elements/Button'

type Props = React.ComponentProps<typeof Button>

export const SeeMoreButton: React.FC<Props> = (props) => (
  <div className="w-[100px]">
    <Button {...props} color="outlined">
      <div className="h-[38px] text-[13px] font-bold leading-[38px]">
        もっと見る
      </div>
    </Button>
  </div>
)
